<script setup>
import { ref, watch, nextTick, onMounted} from "vue"
import axiosIns from "@/plugins/axios.js"
import Banner from '@/views/frontend/pages/trabaja_en_agv/dashboard_postulante/components/banner.vue'
import JobCard from "@/views/frontend/pages/trabaja_en_agv/dashboard_postulante/components/job_card.vue"
import Footer from '@/views/frontend/pages/trabaja_en_agv/dashboard_postulante/components/footer.vue'

const id_applicant = JSON.parse(localStorage.getItem('userData'))?.id_usuario

const filteredData = ref(null)
const allData = ref(null)
const applications = ref([])

const getData = () => {

    const params = {
        applicant_id : id_applicant,
    }

    const config = {
        method: "post",
        url: "/talentoagv/getFavoriteOffers/",
        headers: {
            'Content-Type': 'application/json'
        },
        data: params
    };

    axiosIns(config)
    .then(function (response) {

        let resultado = response.data["result"];
        allData.value = resultado;
        filteredData.value = resultado;

        if (id_applicant) {
            getApplications()
        }

    })
    .catch(function (error) {
        console.log(error);
    });
}

const getApplications = () =>{
  
    const params = {
        applicant_id : id_applicant,
    }

    const config = {
        method: "post",
        url: "/talentoagv/get-applied-offers/",
        data: params
    };

    axiosIns(config)
    .then(function (response) {
        applications.value = response.data["result"];
        console.log(response.data["result"])
        for (let a of filteredData.value) {
            a.isapplicated = applications.value.some(b => a.key_oferta_lab === b.key_oferta_lab_id)
        }

    })
    .catch(function (error) {
        console.log(error);
    });

}

onMounted(() => {
    getData()
})

</script>
<template>
    <Banner/>
    <div class="container my-5">
        <div class="row mb-4">
            <div class="col-12 col-md-8">
                <h6 class="text-agv-siete" style="font-weight: bold;">
                    <i class="fa-solid fa-heart"></i>
                    &nbsp;Mis Favoritos
                </h6>
            </div>
            <div class="col-12 col-md-4" style="display: flex; justify-content: end; flex-wrap: wrap;">
                <router-link v-if="id_applicant" class="text-muted me-4" to="/postulaciones">
                    <i class="fa-solid fa-flag"></i>    
                    Mis Postulaciones
                </router-link>

                <h6 class="text-end" style="text-decoration: underline; text-underline-offset: 6px; color: #1957d1;">
                    <router-link class="text-agv-siete" to="/dashboard_ofertas_laborales">
                        <i class="fa-solid fa-briefcase me-1"></i>
                        &nbsp;Puestos de Trabajo
                    </router-link>
                </h6>
            </div>
        </div>
        <div class="row">
            <template v-for="(job, index) in filteredData" :key="job.id">
                <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                    <div class="content-job-card">
                        <JobCard
                        :id="job.key_oferta_lab"
                        :title="job.work_pos"
                        :vacancies="job.n_vacancy"
                        :place="job.place"
                        :isfavorite="true"
                        :isapplicated="job.isapplicated"
                        :image="job.s3_url"
                        />
                    </div>
                </div>
            </template>
        </div>
    </div>
    <Footer/>
</template>
<style scoped>

.content-job-card {
    margin-top: 100px;
    display: flex;
    justify-content: center;
}

.topbar-link {
    background: transparent;
    border: 0;
    padding: 0;
    color: var(--bg-primary-as);
    display: inline-flex;
    align-items: center;
    font-weight: 500;
    cursor: pointer;
}

.btn-link-reset {
    background: none;
    border: 0;
    padding: 0;
    color: var(--bg-primary-as-light);
    font-weight: 500;
    cursor: pointer;
}

.btn-link-reset:hover {
    text-decoration: underline;
}

</style>